import React from 'react';
import ServiceHome from '../ServiceHome/ServiceHome';
import Title from '../Title/Title';

const Home = () => {
    return (
        <div  >
            <Title></Title>
            <ServiceHome></ServiceHome>
        </div>
    );
};

export default Home;